'use strict';

var angular = require('angular');
var StrategyCustomDirective = function StrategyCustomDirective() {
  return {
    restrict: 'E',
    template: require('../templates/strategy-custom.html'),
    controller: 'StrategyCustomController',
    scope: {
      actionCategories: '=',
      conditionCategories: '=',
      activeEntityType: '=',
      levelOptions: '=',
      closePanelHandler: '&',
      saveStrategyHandler: '&',
      strategy: '=',
      isStatementEmpty: '=?'
    },
    link: function link($scope, element) {
      element.find('.gdpr-popover').popover();
      $scope.$watch('strategy', $scope.resetIfEmpty);
    }
  };
};
StrategyCustomDirective.$inject = [];
module.exports = StrategyCustomDirective;